<template>
	<div class="cart-list">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'CartList',
	components: {},
	data() {
		return {}
	},
	props: {},
	methods: {}
}
</script>

<style lang="scss">
.cart-list {
	margin-top: 20px;

	&__item {
		position: relative;

		& > div {
			@include small {
				background-color: #f7f8f9;
			}

			&:last-of-type {
				background-color: inherit;
			}
		}
	}

	&__mobile-header {
		display: none;
		@include small {
			display: block;
		}
	}
	&__buttons {
		position: absolute;
		top: 0;
		right: 20px;
		z-index: 2;
		top: -20px;
		// @include for-tablet-portrait-up {
		// }
		a,
		button {
			vertical-align: middle;
		}
		svg {
			width: 20px;
			height: 20px;
		}
		button:first-child {
			//margin-right: 20px;
		}
		@include for-tablet-landscape-up {
			top: -20px;
		}
		.btn--dark {
			margin-left: 10px;
		}
	}

	&__image {
		width: 100%;
		margin-top: 20px;
		@include for-tablet-portrait-up {
			margin-top: 40px;
		}
		@include small {
			margin-top: 40px;
			margin-left: 17px;
			width: calc(100% - 17px);
		}
	}

	&__card {
		padding: 20px;
		background-color: #f7f8f9;
		margin-bottom: 40px;
		position: relative;
		margin-bottom: 40px;
		@include for-tablet-portrait-up {
			padding: 27px 40px;
		}
		@include small {
			padding-left: 17px;
		}
	}
	&__head {
		margin-bottom: 10px;
		&--with-border {
			border-bottom: 1px solid #bfc5cf;
			padding-bottom: 23px;
			margin-bottom: 21px;
		}
		@include small {
			display: none;
		}
	}
	&__body {
		&--no-margin {
			margin-top: -40px;
		}
		&--with-upper-border {
			@include small {
				border-top: 0;
				padding-top: 0;
				@include for-tablet-portrait-up {
					padding-top: 22px;
					border-top: 1px solid #bfc5cf;
				}
			}
		}
	}
	// &__foot {
	// }

	&__item-no {
		display: block;
		font-size: 13px;
		line-height: 1.2;
		color: $colorPrimary7;
		margin-bottom: 6px;
		@include small {
			margin-bottom: 0px;
			margin-top: 40px;
			padding-left: 25px;
		}
	}
	&__addon {
		display: block;
		text-align: left;
		@include small {
			margin-left: 15px;
		}
	}
	&__heading,
	&__price {
		display: block;
		color: $colorPrimary;
		font-size: 16px;
		line-height: 18px;
		//padding-right: 20px;
		font-weight: 500;
		margin-bottom: 6px;
		margin-top: 6px;
		@include for-tablet-portrait-up {
			font-size: 20px;
			line-height: 32px;
		}
		a {
			color: $colorPrimary;
		}
	}
	&__heading {
		&--small {
			padding-left: 25px;
		}
		&-text {
			margin-right: 15px;
			display: block;
		}
		&-levels {
			display: inline-block;
			vertical-align: middle;
			line-height: 21px;
		}
		&-buy {
			display: inline-block;
			vertical-align: middle;
			line-height: 21px;
			color: $colorWhite;
			font-size: 9px;
			font-weight: 600;
			line-height: 14px;
			text-transform: uppercase;
			background: #7fc3bb;
			padding: 3px 5px;
			border-radius: 3px;
			margin-left: -10px;
		}
	}
	&__change-btn {
		background-color: inherit;
		border: none;
		font-size: 13px;
		color: $colorPrimary;
		text-decoration: underline;
		&:hover {
			color: $colorPrimary7;
			text-decoration: none;
			cursor: pointer;
		}
		&:focus {
			color: $colorPrimary;
			text-decoration: underline;
			cursor: pointer;
		}
	}
	&__people-list {
		display: block;
		text-transform: lowercase;
		> span {
			&:before {
				content: ' +';
				display: inline;
			}
			&:first-child:before {
				display: none;
			}
		}
		&-breakfast:before {
			display: none;
		}
	}
	&__addon-labels {
		margin-top: 7px;

		&-headline {
			display: block;
			text-transform: uppercase;
			color: $colorGrey8;
			font-size: 10px;
			font-weight: 500;
			margin: 10px 0 5px 0;
		}

		// ul {
		// }

		li {
			display: inline-block;
			background: $colorPrimary1;
			margin: 0 5px 5px 0;
			padding: 5px 8px;
			border-radius: 4px;
			font-size: 13px;
			line-height: 15px;
			color: $colorPrimary8;
		}
	}
	&__validity {
		display: block;
		color: $colorPrimary7;
		font-size: 12px;
		font-weight: 400;
		line-height: 1.5;
		@include small {
			margin-bottom: 0px;
			padding-left: 25px;
		}
	}
	&__price {
		text-align: right;
		margin-top: 21px;
	}
	&__sub-heading {
		width: 100%;
		display: block;
		color: $colorPrimary;
		font-size: 15px;
		font-weight: 500;
		line-height: 1.2;
		margin-bottom: 14px;
	}
	&__addon-heading {
		width: 100%;
		display: block;
		color: $colorPrimary;
		font-size: 15px;
		font-weight: 500;
		line-height: 1.2;
		margin-bottom: 5px;
		text-align: left;
		//margin-top: 20px;
	}
	&__addon--desktop {
		@include for-phone-only {
			visibility: hidden;
			height: 0;
		}
	}
	&__addon--mobile {
		margin-top: 20px;
		@include for-tablet-portrait-up {
			div {
				display: none;
			}
			div:first-child {
				display: flex;
			}
		}
	}

	&__companion {
		margin-top: 20px;
		@include small {
			margin-top: 0px;
		}
	}
	&__select {
		width: 100%;
		margin-bottom: 18px;
	}
	&__guest {
		margin-bottom: 18px;
		font-size: 14px;
		line-height: 18px;
		// word-break: break-all;

		p {
			margin-bottom: 0 !important; //Furillo css override
			display: flex;
		}
		&-label {
			display: inline-block;
			width: 120px;
			color: $colorPrimary7;
			margin-bottom: 5px;
			@include for-tablet-portrait-up {
				width: 160px;
			}
		}
		&-info {
			display: inline-block;
			color: $colorPrimary;
			font-weight: 500;
			margin-bottom: 5px;
			@include for-phone-only {
				max-width: 150px;
			}
		}
	}
	&__login {
		border: 2px solid #04befb;
		border-radius: 5px;
		background-color: #ffffff;
		padding: 20px;
		.cart-list__sub-heading {
			margin-bottom: 2px;
		}
		p {
			font-size: 14px;
			color: #4a4a4a;
			margin-bottom: 12px;
		}
		a {
			margin-right: 10px;
		}
	}
	&__table {
		margin-bottom: 20px;
		border-bottom: 1px solid $colorPrimary6;
		&-head {
			justify-content: flex-end;
			text-align: right;
			border-bottom: 1px solid $colorPrimary6;
			font-size: 14px;
			color: $colorPrimary6;
			padding: 5px 0 14px;
			&--with-upper-margin {
				margin-top: 20px;
			}
		}
		&-item {
			font-size: 12px;
			color: $colorPrimary6;
			border-bottom: 1px solid $colorPrimary3; //#BFC5CF
			padding: 20px 0;

			display: flex;
			justify-content: flex-end;
			@include small {
				padding: 15px 0;
			}

			&:last-child {
				border: none;
			}
		}
		&-item:first-child {
			border-top: 1px solid $colorPrimary6;
		}
		&-label {
			position: relative;
			.textarea-wrapper {
				margin: 15px 0 6px 0;
				textarea {
					height: 80px;
				}
			}
			.input-wrapper {
				display: flex;
				align-items: center;
				@include small {
					margin-bottom: 5px;
				}
			}
			.select__container {
				margin: 15px 0 6px 0;
			}
		}
		&-unit-price {
			text-align: right;
			font-size: 13px;
			&--align-end {
				align-self: flex-end;
				margin-bottom: 2px;
			}
			&--align-center {
				align-self: center;
			}
		}
		&-price {
			text-align: right;
			font-size: 13px;
			color: $colorPrimary;
			&--align-end {
				align-self: flex-end;
				margin-bottom: 2px;
			}
			&--align-center {
				align-self: center;
			}
		}
	}
	&__input-label {
		color: #444;
		font-size: 16px;
		line-height: 18px;
		margin-bottom: 7px;
		+ .booking-tooltip {
			margin-bottom: 7px;
		}
	}
	&__login {
		margin: 10px 0;
	}

	&__item--addon {
		.cart-list__card {
			border-left: 3px solid $colorSecondary;
			margin-top: -10px;
		}
		.cart-list__icon {
			height: 50px;
			width: 50px;
			background: $colorWhite;
			box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
			border-radius: 50%;
			position: absolute;
			left: -25px;
			top: 14px;
			padding: 13px;
			box-sizing: border-box;
			svg {
				width: 23px;
				height: 23px;
				fill: $colorSecondary;
			}
		}
	}
}
</style>
